<template>
  <div class="toolbar clearfix">
    <div  class="search">
      <div class="search-icon"><i class="iconfont icon-search"></i></div>
      <!-- <input type="text" class="form-control" id="tipinput" placeholder="输入机构名称精确查找"> -->
      <input class="form-control" id="tipinput" type="text" placeholder="输入机构名称精确查找"
      v-model="searchff"
      v-on:keyup.stop.prevent="aacf(searchff,$event)"
      v-on:mousedown="djshowf()"
      v-on:mouseout="focusListff=-1"
      v-on:click="focusListff=-1"
      v-on:blur="foucf()">
      <a href="javascript:;" class="clean-icon" v-on:click="focusListff=-1;searchff=''"  v-if="searchff.length"><i class="iconfont icon-clean"></i></a>
      <!-- 搜索的列表 -->
      <div class="search-list"
           v-bind:class="{ historyList: butshow }"
           v-if="innbool" v-on:mouseout="focusListff=-1">
        <div class="sear-title">
          <span v-if="butshow">历史纪录</span>
          <span v-if="!butshow">机构搜索结果</span>
        </div>
        <ul class="search-result">
          <li
            v-bind:class="{ active: item.kai }"
            v-for="(item,index) in screening"
            v-on:click="aabf(item.name);">
            <a href="javascript:;">
              <i class="iconfont icon-org-expertise" v-if="item.tpn === '司法鉴定所' && !butshow"></i>
              <i class="iconfont icon-judicial" v-if="item.tpn === '公证处' && !butshow"></i>
              <i class="iconfont icon-legalperson" v-if="item.tpn === '律师事务所' && !butshow"></i>
              <i class="iconfont icon-org-aid" v-if="item.tpn === '法援机构' && !butshow"></i>
              <i class="iconfont icon-organization" v-if="item.tpn === '人民调解委员会' && !butshow"></i>
              {{ item.name }}
            </a>
          </li>
        </ul>
        <div class="sear-title" v-if="hShow">地理范围搜索结果-{{searchff}}</div>
        <ul class="search-result">
          <li
            v-if="item.lat"
            v-bind:class="{ active: item.kai }"
            v-for="(item,index) in newArrScreen"
            v-on:click="naabf(item)">
            <a href="javascript:;">
              <i class="iconfont icon-local"></i>
              {{ item.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="filter">
      <ul class="filter-wrap">
        <li class="filter-item area"><a href="javascript:;" v-on:mouseover="quff=true" v-on:mouseout="quff=false" v-text="qyff"></a>
          <ol v-show="quff" v-on:mouseover="quff=true" v-on:mouseout="quff=false">
            <li v-on:click="clearlf();qyff='区域筛选'">全部区域</li>
            <li v-if="item['longitudeGD']" v-for="(item,index) in zoomCode" v-text="item.name" v-on:click="shof(index,item,item.count,item.code,item.name);qyff=item.name;" v-on:mouseover="hoverCityOverf(item)" v-on:mouseout="hoverCityOutf(item)"></li>
          </ol>
        </li>
        <li v-show="qubff" class="filter-item type-status"><a href="javascript:;" v-on:mouseover="qucff=true" v-on:mouseout="qucff=false" v-text="jd">街道筛选</a>
          <ol class="strac-warp" v-show="qucff"  v-on:mouseover="qucff=true" v-on:mouseout="qucff=false">
            <li v-on:click="clearjdf()">全部街道</li>
            <li v-for="(item,index) in stract" v-text="item.name" v-on:click="abaf(item.code,item.count,item.name,index,item);" v-if="item.number!=0"></li>
          </ol>
        </li>
        <li class="filter-item typea"><a href="javascript:;" v-on:mouseover="quaff=true" v-on:mouseout="quaff=false" v-text="jg">机构类型筛选</a>
          <ol v-show="quaff" v-on:mouseover="quaff=true" v-on:mouseout="quaff=false">
            <li v-on:click="clearfff()">全部类型</li>
            <li v-for="(item,index) in typename" v-text="item.name" v-on:click="shobf(item.name,item.id)"></li>
          </ol>
        </li>
        <li class="filter-clear"><a href="javascript:void(0);" v-on:click="clearff();qyff='区域筛选'"><i class="iconfont icon-clear"></i>清空</a></li>
      </ul>
    </div>
    <div class="mod-switch">
      <a href="//sh.12348.gov.cn/sites/12348/team.jsp?active=0f4806060c7e4b669ea3f997525cacd7" target="_blank"><i class="iconfont icon-list" target="_blank"></i>列表模式</a>
    </div>
    <div class="toolbar-bg"></div>
  </div>
</template>
<script>
    export default {
      props: [
        'search',
        'aac',
        'djshow',
        'focusList',
        'fouc',
        'butshow',
        'screening',
        'newArrScreen',
        'hShow',
        'aab',
        'naab',
        'qu',
        'qy',
        'clearl',
        'zoomCode',
        'hoverCityOver',
        'hoverCityOut',
        'qub',
        'quc',
        'clearjd',
        'stract',
        'aba',
        'qua',
        'jg',
        'clearf',
        'typename',
        'shob',
        'clear',
        'innbool',
        'jd',
        'sho'
      ],
      data () {
        return {
          quff: this.qu,
          qubff: this.qub,
          quaff: this.qua,
          qyff: this.qy,
          qucff: this.quc,
          searchff: this.search,
          focusListff: this.focusList
        }
      },
      watch: {
        qub: function () {
          this.qubff = this.qub
        },
        qy: function () {
          this.qyff = this.qy
        },
        innbool: function () {
        }
      },
      methods: {
        aacf: function (tet, event) {
          this.aac(tet, event)
        },
        clearlf: function () {
          this.clearl()
        },
        djshowf: function () {
          this.djshow()
        },
        foucf: function () {
          this.fouc()
        },
        aabf: function (inner) {
          this.aab(inner)
        },
        naabf: function (inner) {
          this.naab(inner)
        },
        shof: function (index, item, num, code, name) {
          this.sho(index, item, num, code, name)
          this.qubff = true
        },
        hoverCityOverf: function (item) {
          this.hoverCityOver(item)
        },
        hoverCityOutf: function (item) {
          this.hoverCityOut(item)
        },
        clearjdf: function () {
          this.clearjd()
        },
        abaf: function (code, num, name, index, item) {
          this.aba(code, num, name, index, item)
        },
        clearff: function () {
          this.clear()
          this.qubff = false
        },
        clearfff: function () {
          this.clearf()
        },
        shobf: function (name, id) {
          this.shob(name, id)
        }
      }
    }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .toolbar{
    z-index: 900;
    position: absolute;
    width: 100%;
    height: 48px;
    .toolbar-bg{
      z-index: -1;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: #4a4a4a;
      opacity: .87;
    }
    .search{
      position: relative;
      float: left;
      padding: 7px 15px 0 15px;
      .form-control{
        float: left;
        padding: 0 34px 0 10px;
        height: 34px;
        border: none;
        border-radius: 4px;
        outline: none;
        width: 280px;
      }
      .search-icon{
        z-index: 10;
        position: absolute;
        right: 15px;
        top: 7px;
        width: 34px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        color: #bbb;
      }
      .clean-icon{
        z-index: 10;
        position: absolute;
        right: 15px;
        width: 34px;
        height: 34px;
        line-height: 36px;
        text-align: center;
        color: #bbb;
        .iconfont{
          font-size: 18px;
        }
        &:hover{
          color: $gray-light;
        }
      }
    }
    .search-list{
      position: absolute;
      top: 38px;
      overflow: hidden;
      padding-top: 3px;
      width: 280px;
      background-color: $white;
      .sear-title {
        padding-right: 10px;
        padding-left: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 15px;
        font-weight: bold;
        color: $gray-dark;
      }
    }
    .historyList{
      a{
        position: relative;
        padding-left: 30px !important;
        &:before{
          content: '\e625';
          position: absolute;
          left: 10px;
          top: 11px;
          font-family: "iconfont";
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          color: $gray-light;
        }
        &:hover{
          &:before{
            color: $white;
          }
        }
      }
    }
    .search-result{
      margin: 0;
      padding: 0;
      border-radius: 0 0 4px 4px;
      list-style: none;
      border: 1px solid $gray-lighter;
      background: $white;
      li{
        position: relative;
        border-bottom: 1px solid $gray-lighter;
        &:last-child{
          border-bottom: none;
        }
        .iconfont.icon-org-expertise {
          float: left;
          margin-top: 5px;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          display: inline-block;
          font-size: 12px;
          border-radius: 50%;
          color: transparent;
          border:3px solid red;
        }
        .iconfont.icon-org-aid {
          float: left;
          margin-top: 5px;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          display: inline-block;
          font-size: 12px;
          border-radius: 50%;
          color: transparent;
          border:3px solid #0fa3b1;
        }
        .iconfont.icon-judicial{
          float: left;
          margin-top: 5px;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          display: inline-block;
          font-size: 12px;
          border-radius: 50%;
          color: transparent;
          border:3px solid #1ab99b;
        }
        .iconfont.icon-legalperson {
          float: left;
          margin-top: 5px;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          display: inline-block;
          font-size: 12px;
          border-radius: 50%;
          color: transparent;
          border:3px solid #348ac7;
        }
        .iconfont.icon-organization {
          float: left;
          margin-top: 5px;
          margin-right: 5px;
          width: 10px;
          height: 10px;
          display: inline-block;
          font-size: 12px;
          border-radius: 50%;
          color: transparent;
          border:3px solid #009900;
        }
        .iconfont.icon-local {
          color: #ccc;
          border: none;
        }
      }
      a{
        display: block;
        padding: 10px;
        color: $gray-base;
        &:hover{
          color: $white;
          background-color: $brand;
        }
      }
      .active{
        background-color: $brand;
        a{
          color: $white;
          &:before {
            color: $white;
          }
        }
      }
    }
    .mod-switch{
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;
      height: 100%;
      a{
        display: block;
        height: 48px;
        line-height: 48px;
        text-align: center;
        color: $white;
        background-color: $brand;
        &:hover{
          background-color: lighten($brand, 4%);
        }
      }
      .iconfont{
        display: inline-block;
        vertical-align: middle;
        padding-right: 4px;
        font-size: $font-size-base;
      }
    }
  }
  .filter{
    float: left;
    height: 100%;
    .filter-wrap{
      margin: 0;
      padding: 0;
      height: 100%;
      list-style: none;
      @inculde clearfix();
      .filter-item{
        float: left;
        height: 100%;
        border-left: 1px solid rgba(255,255,255,.3);
        a{
          position: relative;
          display: block;
          padding: 0 30px 0 15px;
          line-height: 48px;
          color: $white;
          text-align: center;
          &:after{
            content: '';
            position: absolute;
            right: 13px;
            top: 50%;
            margin-top: -2px;
            border: 5px solid transparent;
            border-top-color: $white;
          }
          &:hover{
            color: $brand-orange;
            &:after{
              border-top-color: $brand-orange;
            }
          }
        }
      }
      .filter-item.area {
        width: 110px;
      }
      .filter-item.typea {
        min-width: 150px;
      }
      .filter-item.type-status {
        width: 150px;
        a {
          display: block;
          width: 100%;
          height: 100%;
          text-overflow:ellipsis;
          overflow: hidden;
          white-space:nowrap;
        }
      }
      ol {
        list-style: none;
        background: rgba(0,0,0,0.6);
        margin: 0;
        padding: 0;
        li {
          width: 100%;
          height: 30px;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
          color: $white;
          padding-left: 5px;
          padding-right: 5px;
          text-overflow:ellipsis;
          overflow: hidden;
          white-space:nowrap;
        }
        li:hover {
          background: $gray-light;
        }
      }
      .strac-warp {
        max-height: 800px;
        overflow-y: auto;
      }
    }
    .filter-clear{
      float: left;
      height: 100%;
      border-left: 1px solid rgba(255,255,255,.3);
      a{
        display: block;
        padding: 0 30px 0 15px;
        line-height: 48px;
        color: $white;
        &:hover{
          color: $brand-orange;
        }
      }
      .iconfont{
        padding-right: 6px;
        font-size: $font-size-base;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// filter.vue?755d335f